import { render } from "./QuickMatrixTop.vue?vue&type=template&id=d01485ee&scoped=true"
import script from "./QuickMatrixTop.vue?vue&type=script&lang=js"
export * from "./QuickMatrixTop.vue?vue&type=script&lang=js"

import "./QuickMatrixTop.vue?vue&type=style&index=0&id=d01485ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01485ee"]])

export default __exports__